import { environment } from '@lla-platform/core/core-util'

export const SERVICE_CATEGORIES_API_URL = {
  thresoldsBase: `${environment.apiUrl}/servicecategories/thresold`,
  adminThresoldsBase: `${environment.apiUrl}/admin/servicecategories/thresold`,
  getServiceCategories: `${environment.apiUrl}/servicecategories`
}
